import axios from "./axios";

export const getNodegroups = async () => {
  try {
    const nodegroupList = await axios.get("/api/v1/provision/nodegroup");
    return nodegroupList;
  } catch (error) {
    return { status: "error", error };
  }
};

export const getSharedNodegroups = async () => {
  try {
    const nodegroupsList = await axios.get(
      "/api/v1/provision/nodegroup?op=list.shared",
    );
    return nodegroupsList;
  } catch (err) {
    return { status: "error", error: err };
  }
};

export const getNodegroupDetail = async (id) => {
  try {
    const data = await axios.get(`/api/v1/provision/nodegroup/${id}`);
    return data;
  } catch (error) {
    return { status: "error", error };
  }
};

export const startNodeGroup = async (id) => {
  try {
    const data = await axios.post(`/api/v1/provision/nodegroup/${id}?op=start`);
    return data;
  } catch (error) {
    return { status: "error", error };
  }
};

export const stopNodeGroup = async (id) => {
  try {
    const data = await axios.post(`/api/v1/provision/nodegroup/${id}?op=stop`);
    return data;
  } catch (error) {
    return { status: "error", error };
  }
};

export const deleteNodeGroup = async (id) => {
  try {
    const data = await axios.delete(`/api/v1/provision/nodegroup/${id}`);
    return data;
  } catch (error) {
    return { status: "error", error };
  }
};

export const createNodegroup = async (value) => {
  const data = await axios.put("/api/v1/provision/nodegroup", value);
  return data;
};

export const updateNodegroup = async (id, value) => {
  const data = await axios.post(
    `/api/v1/provision/nodegroup/${id}?op=update`,
    value,
  );
  if (data.status === "Error") {
    return { status: "error", error: data.message };
  }
  return data;
};

export const retryCreateNodeGroup = async (id) => {
  try {
    const data = await axios.post(`/api/v1/provision/nodegroup/${id}?op=retry`);
    return data;
  } catch (error) {
    return { status: "error", error: error?.message };
  }
};
